import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { config } from "../App";
import { useSnackbar } from "notistack";
import { DialogContent } from "@mui/material";
import "./Header.css";
import Box from "@mui/material/Box";

const model = {
  height: "100vh",
  width: "500px",
  position: "absolute",
  left: "30%",
};

let genre = ["All genre", "Education", "Sports", "Comedy", "Lifestyles"];

let ageGroup = ["Any Age", "7+", "12+", "16+", "19+"];

const UploadModel = ({ open, cancelHandler }) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [data, setData] = useState({
    videoLink: "",
    previewImage: "",
    title: "",
    genre: "",
    contentRating: "",
    releaseDate: "",
  });

  const onUpdate = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    console.log(data);
  };

  const postVideoData = async (formData) => {
    console.log(formData);
    if (
      !formData.videoLink ||
      !formData.previewImage ||
      !formData.title ||
      !formData.genre ||
      !formData.contentRating ||
      !formData.releaseDate
    ) {
      alert("Every Field is required");
    } else {
      try {
        const response = await axios.post(`${config.endpoint}/v1/videos`, {
          videoLink: formData.videoLink,
          previewImage: formData.previewImage,
          title: formData.title,
          genre: formData.genre,
          contentRating: formData.contentRating,
          releaseDate: formData.releaseDate,
        });

        console.log("uploaded :: ", response.data);
        setData({
          videoLink: "",
          previewImage: "",
          title: "",
          genre: "",
          contentRating: "",
          releaseDate: "",
        });
        navigate("/");
      } catch (error) {
        enqueueSnackbar(error, { variant: "error" });
      }
    }
  };
  const handleCancelUploadShow = () => {
    open = false;
  };

  return (
    <Dialog open={open} style={model}>
      <DialogTitle>Upload Video</DialogTitle>
      <DialogContent>
        <TextField
          id="outlined-basic"
          label="video Link"
          variant="outlined"
          name="videoLink"
          fullWidth
          helperText="This link will be used to derive the video"
          className="upload-text"
          onChange={(e) => onUpdate(e)}
        />

        <TextField
          id="outlined-basic"
          label="thumbnail image"
          variant="outlined"
          name="previewImage"
          fullWidth
          helperText="This link will be used to preview the thumbnail image"
          className="upload-text"
          onChange={(e) => onUpdate(e)}
        />

        <TextField
          id="outlined-basic"
          label="title"
          variant="outlined"
          name="title"
          fullWidth
          helperText="The title will be the representative text for video"
          className="upload-text"
          onChange={(e) => onUpdate(e)}
        />

        <TextField
          id="outlined-select-currency-native"
          select
          //   onChange={handleChange}
          SelectProps={{
            native: true,
          }}
          helperText="Genre will help in categorizing your videos"
          name="genre"
          fullWidth
          className="upload-text"
          onChange={(e) => onUpdate(e)}
        >
          {genre.map((option, index) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </TextField>

        <TextField
          id="outlined-select-currency-native"
          select
          SelectProps={{
            native: true,
          }}
          helperText="This will be used to filter videos on age group suitability"
          name="contentRating"
          fullWidth
          className="upload-text"
          onChange={(e) => onUpdate(e)}
        >
          {ageGroup.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </TextField>
        <TextField
          id="outlined-basic"
          variant="outlined"
          type="date"
          name="releaseDate"
          fullWidth
          helperText="This will be used to sort videos"
          className="upload-text"
          onChange={(e) => onUpdate(e)}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            p: 1,
            m: 1,
          }}
        >
          <Button
            variant="contained"
            id="upload-button"
            onClick={() => {
              postVideoData({
                videoLink: data.videoLink,
                previewImage: data.previewImage,
                title: data.title,
                genre: data.genre,
                contentRating: data.contentRating,
                releaseDate: data.releaseDate,
              });
            }}
          >
            Upload
          </Button>
          <Button
            variant="text"
            sx={{ bgcolor: "none", color: "black" }}
            onClick={cancelHandler}
          >
            cancel
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default UploadModel;
